import { gql } from 'graphql-request';
import { request } from '@/utilities/graphQLClient';

import { NARRATIVE_FRAGMENT } from '@/pages/NarrativeList/hooks/narrative-fragment';
import type { QueryContext, QueryResponse } from './types';

export const queryFn = async ({
  queryKey: [_, canonicalUrl],
}: QueryContext) => {
  const { NarrativesByCompanyCanonical, errors } = await request<QueryResponse>(
    gql`
      query NarrativesByCompanyCanonical($canonicalUrl: String!) {
        NarrativesByCompanyCanonical(companyCanonicalUrl: $canonicalUrl) {
          ...NarrativeFields
        }
      }
      ${NARRATIVE_FRAGMENT}
    `,
    {
      canonicalUrl,
    }
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return NarrativesByCompanyCanonical;
};
